var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmailWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 18,
    viewBox: "0 0 23 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 2.81791V15.9537C22.5 16.807 21.8288 17.4992 21.0006 17.4992H17.4994V8.74229L11.4996 13.3796L5.4999 8.74229V17.5H1.99938C1.1712 17.5 0.5 16.8085 0.5 15.9552V2.81866C0.5 1.53841 1.50717 0.5 2.74981 0.5C3.25889 0.5 3.72837 0.67458 4.10541 0.967814L4.09955 0.963279L11.4996 6.68209L18.8997 0.963279C19.2709 0.673824 19.7404 0.5 20.2495 0.5C21.4921 0.5 22.5 1.53765 22.5 2.81791Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmailWhite);
export default __webpack_public_path__ + "static/media/gmail-white.3ee890b1de65ccd305ad6a62c826b6bc.svg";
export { ForwardRef as ReactComponent };